import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import PageTitle from '../components/title/PageTitle'
import Star from '../assets/svgs/star.svg'
import ArrowRight from '../assets/svgs/arrow-right.svg'
import DashboardMockup from '../assets/images/browser.png'
import LightBulb from '../assets/svgs/lightbulb.svg'
import ChatScreen from '../assets/images/mockups/chat+screen.webp'
import TextScreen from '../assets/images/mockups/text+screen.webp'
import EngagementIcon from '../assets/svgs/engagement-icon.svg'
import ResolutionIcon from '../assets/svgs/list-checks.svg'
import TrophyIcon from '../assets/svgs/trophy.svg'
import Lines from '../assets/svgs/lines.svg'
import HandsOnMockup from '../assets/images/mockups/hands-on.webp'
import UniqueLink from '../assets/images/mockups/unique+link.webp'
import QrcodeVideo from '../assets/video/scan+qrcode.mp4'
import UnassignVid from '../assets/video/Unassign3.mp4'
import UpdateStatus from '../assets/video/update+status.webm'
import HeroVideo from '../assets/video/cs_hero_video.mp4'
import AnalyseIcon from '../assets/svgs/analyse-icon.svg'
import Mockup01 from '../assets/images/mockup01.webp'
import Waitlist from '../components/modals/Waitlist'
import FaqSection from '../components/FaqSection'
import Close from '../assets/svgs/close.svg'
import Ihvn from '../assets/images/clients/ihvn.png'
import Ditto from '../assets/images/clients/ditto.png'
import Firmcare from '../assets/images/clients/firmcare.png'
import Valuejet from '../assets/images/clients/valuejet.png'
import pfp1 from '../assets/images/clients/pfp/pfp1.svg'
import pfp2 from '../assets/images/clients/pfp/pfp2.webp'
import pfp3 from '../assets/images/clients/pfp/pfp3.webp'
import pfp4 from '../assets/images/clients/pfp/pfp4.svg'
import pfp5 from '../assets/images/clients/pfp/pfp5.webp'
import pfp6 from '../assets/images/clients/pfp/pfp6.webp'
import ussdMockup from '../assets/images/mockups/ussd.webp'
import whatsappMockup from '../assets/images/mockups/whatsapp+flow.webm'
import PlayIcon from '../assets/svgs/play-circle-filled.svg'
import ElectionPulsePreview from '../assets/images/home-figma/election-pulse-preview.png'
import SolutionDeviceLeft from '../assets/images/home-figma/solution-devices/solution-device-left.png'
import SolutionDeviceCenter from '../assets/images/home-figma/solution-devices/solution-device-center.png'
import SolutionDeviceRight from '../assets/images/home-figma/solution-devices/solution-device-right.png'
import CtaMockup from '../assets/images/home-figma/election-cta/election-cta-mockup.png'
import PulseFlag from '../assets/svgs/pulse-flag.svg'
import PulseChart from '../assets/svgs/pulse-chart.svg'
import PulseBuilding from '../assets/svgs/pulse-building.svg'

const faqContent = {
  title: 'Frequently Asked Questions',
  columns: [
    [
      {
        title: 'What is Clientshot?',
        desc: 'Clientshot is a customer satisfaction tool that helps businesses collect and analyze feedback from their customers.',
      },
      {
        title: 'How does Clientshot measure customer satisfaction?',
        desc: 'Clientshot measures customer satisfaction by collecting feedback from customers through various channels, such as USSD, Web, and WhatsApp. The feedback is analyzed to calculate metrics such as Net Promoter Score and Customer Satisfaction.',
      },
      {
        title: 'How does Clientshot collect customer feedback?',
        desc: 'Clientshot collects customer feedback through USSD, Web, and WhatsApp. The feedback can be collected through surveys, ratings, and other forms of interaction.',
      },
      {
        title: 'How does Clientshot help businesses improve their customer satisfaction?',
        desc: 'Clientshot helps businesses improve their customer satisfaction by providing insights into how customers feel about their experience with the business. The feedback and analytics provided by Clientshot help businesses identify areas for improvement and make changes that will result in better customer satisfaction.',
      },
    ],
    [
      {
        title: 'What metrics does Clientshot track?',
        desc: 'Clientshot tracks metrics such as Net Promoter Score and Customer Satisfaction. The built-in analytics also provide insights into the impact of customer feedback on these metrics over time.',
      },
      {
        title: 'How is customer data stored and protected by Clientshot?',
        desc: 'Customer data is stored securely by Clientshot and is protected by industry-standard security measures.',
      },
      {
        title: 'How can I get started with Clientshot?',
        desc: 'To get started with Clientshot, you can click this link or contact us for more information.',
      },
    ],
  ],
}

const realTimeHighlights = [
  {
    title: 'Live Election Polls',
    desc: 'Vote on presidential, governorship, and House of Representatives elections.',
    icon: PulseFlag,
  },
  {
    title: 'Real Time Results',
    desc: 'Watch public sentiment evolve as votes are submitted across Nigeria.',
    icon: PulseChart,
  },
  {
    title: 'State by State Insights',
    desc: 'Explore trends and preferences across all states and the FCT.',
    icon: PulseBuilding,
  },
]

const Home = () => {
    const screenY = window.innerHeight
    const [channel, setChannel] = useState(0)
    const [engagement, setEngagement] = useState(0)
    const [shortenUrl, setshortenUrl] = useState(false)
    const [modal, setModal] = useState(false);
    const closeModal = () => setModal(!modal)

    const [industry, setIndustry] = useState(0);
    const [popup, setPopup] = useState(false)
    
    useEffect(() => {
      const loopEngagment = setTimeout(() => {setEngagement(engagement === 0 ? 1 : 0)}, 5000);
      return () => clearTimeout(loopEngagment)
    },)

    useEffect(() => {
        const backgroundVid = setTimeout(() => {setIndustry(industry === 2 ? 0 : industry + 1)}, 5000);
        return () => clearTimeout(backgroundVid)
      },)

    return (
        <>
            <Waitlist modal={modal} closeModal={closeModal} />
            <PageTitle title="Home | Clientshot Website" /> 
            
            <div className='mx-auto section-top'>
                {/* Hero Section */}
                <div className="md:flex justify-between md:gap-x-4 healthcare-video figma-home-hero relative">
                    <video className="hero-background-video" src={HeroVideo} autoPlay loop muted playsInline aria-hidden="true" />
                    <div className='flex flex-col justify-center items-center col-1 p-4 md:p-8 mt-8 md:mt-24 w-full'>

                        <div className='text-white hero-section home-hero-max-w'>
                            <div className="hero-eyebrow mx-auto">
                                The platform behind customer insights and public opinion initiatives
                            </div>
                            <div className='heading-two text-center hero-heading' id='hero-heading'>
                                Capture Every Voice. <br />Unlock Insights That Drive Growth
                            </div>
                            <div className="heading-six secondary-100 text-center mt-6 md:mt-6 desc font-normal">
                                Turn feedback into insights, action, and better decisions for businesses and public initiatives like Election Pulse.
                            </div>
                            <div className='hero-actions flex flex-col sm:flex-row justify-center gap-6 md:mt-4'>
                                <button
                                    onClick={() => setPopup(true)}
                                    className='btn btn-alt btn-lg mt-6 flex gap-2 w-max'>
                                    <img src={PlayIcon} alt="" />
                                    Watch demo
                                </button>
                                <Link
                                    
                                    to={`/election-pulse`}
                                    className='btn btn-primary btn-lg mt-6 flex gap-2 w-max'>
                                    Explore Election Pulse
                                    
                                </Link>
                            </div>
                            <div className=' flex flex-col justify-center stars items-center mt-12 md:mt-12 mb-8 md:mb-0'>
                                <div className='flex gap-2'>
                                    
                                    <img src={Star} alt="star" />
                                    <img src={Star} alt="star" />
                                    <img src={Star} alt="star" />
                                    <img src={Star} alt="star" />
                                    <img src={Star} alt="star" />
                                </div>
                                <div className="hero-star-divider"></div>
                                <p className="base-text-m mt-2.5 md:mt-4">
                                    The Ultimate Customer Feedback Solution for
                                </p>
                                <div className="flex heading-four">
                                    <p className="primary-500 mr-1 ">
                                        {industry === 0 ? 'HealthCare' : industry === 1 ? 'Aviation' : 'Banking'}
                                    </p>
                                    Industry
                                </div>
                            </div>

                            
                        </div>
                    </div>

                    <div className='w-max scroll-line cursor-pointer' onClick={() => window.scrollTo(0, screenY- 50)}>
            
                    </div>
                </div>

                {/* Real-time Feedback Section */}
                <section className="home-pulse-section px-4 md:px-8 py-20">
                    <div className="home-section-shell">
                        <div className="home-pulse-divider" aria-hidden="true">
                            <span>Election Pulse</span>
                        </div>

                        <div className="home-pulse-heading flex flex-col md:flex-row md:items-start justify-between gap-6 mb-10">
                            <div>
                                <h2 data-aos="fade-up" className="heading-four secondary-400">
                                    Nigeria&apos;s Voice, Captured in <br className="hidden md:block" />Real Time
                                </h2>
                                <div data-aos="fade-up" className="home-pulse-actions flex flex-col sm:flex-row gap-4 mt-4">
                                    <Link to="/election-pulse" className="btn btn-primary">
                                        Explore Election Pulse
                                    </Link>
                                    <button type="button" onClick={() => setPopup(true)} className="btn btn-secondary">
                                        View Live Results
                                    </button>
                                </div>
                            </div>
                            <p data-aos="fade-up" className="base-text secondary-300 home-section-desc">
                                Discover how Nigerians are voting, what issues matter most to them, and how public sentiment is evolving ahead of the elections.
                            </p>
                        </div>

                        <img data-aos="zoom-in-up" src={ElectionPulsePreview} loading="lazy" className="home-pulse-image" alt="Clientshot Pulse election polling preview" />

                        <div className="home-pulse-features mt-10">
                            {realTimeHighlights.map((item) => (
                                <div data-aos="fade-up" className="home-highlight" key={item.title}>
                                    <div className="home-highlight-icon">
                                        <img src={item.icon} alt="" />
                                    </div>
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Problem Statement */}
                <div className='pt-16 md:pt-16 p-8 section-one overflow-hidden'>

                    <div className='mb-14 md:mb-2'>
                        <div data-aos="fade-up" className="heading-six font-bold satisfaction secondary-200 " >
                        Unaddressed complaints harm sales and reputation
                        </div>
                        <div data-aos="fade-up" className="heading-four md:w-2/4">
                           <span className='primary-500'>Discover</span>  how Clientshot can improve your Customer Experience
                        </div>
                    </div>

                </div>

                <div className='flex justify-center screens overflow-hidden'>
                        <img src={Mockup01} loading="lazy" alt="" className="h-full" />
                        <img src={Mockup01} loading="lazy" alt="" className="h-full" /> 
                         <img src={Mockup01} loading="lazy" alt="" className="h-full" />
                    </div>

                <div className="hrline w-full mb-8 mt-16"></div>

                {/* Solution Section */}
                <section className="home-solution-section px-4 md:px-8">
                    <div className="home-solution-shell">
                        <div className="home-solution-copy">
                            <div data-aos="fade-up" className="pill secondary-400 small-text mb-4">
                                <img src={LightBulb} alt="" />
                                Our Solution
                            </div>
                            <h2 data-aos="fade-up" className="heading-four secondary-400">
                                Empowering Business Success through <span className="primary-500">Customer Feedback</span>
                            </h2>
                            <p data-aos="fade-up" className="base-text secondary-400">
                                ClientShot is a cutting-edge feedback system designed to assist businesses in gathering valuable insights, including identifying pain points and receiving suggestions from customers.
                            </p>
                            <p data-aos="fade-up" className="base-text secondary-400">
                                The application also provides tools to effectively address and resolve customer complaints, ensuring continuous improvement and satisfaction for customers.
                            </p>
                        </div>

                        <div data-aos="zoom-in-up" className="home-solution-mockups" aria-label="ClientShot feedback form previews on tablet screens">
                            <div className="home-solution-shadow" aria-hidden="true"></div>
                            <img src={SolutionDeviceLeft} loading="lazy" className="solution-device solution-device-left" alt="" />
                            <img src={SolutionDeviceCenter} loading="lazy" className="solution-device solution-device-center" alt="" />
                            <img src={SolutionDeviceRight} loading="lazy" className="solution-device solution-device-right" alt="" />
                        </div>
                    </div>
                </section>

                <div className=" p-4 md:p-8 pt-40 ">
                    <div className="w-full section-four">
                        <div>
                            <img src={Lines} alt="lines" className='w-full' />
                            <div className='flex flex-col p-4 items-center w-full -mt-[18px]'>
                                <div data-aos="fade-up" className="pill secondary-400 small-text mb-4">
                                    Collect Feedback
                                </div>
                            
                                <div data-aos="fade-up" className="heading-four text-center mb-2 secondary-400">How customer feedbacks are <span className='primary-500'>captured</span></div>
                                <div data-aos="fade-up" className="base-text text-center secondary-400 font-normal">
                                    Various channels are available for businesses to efficiently capture customer feedback for resolution.
                                </div>
                            </div>
                        </div>

                        <div>
                        <div data-aos="fade-up" className=" items-center mt-8 flex justify-center">
                    <div className="flex flex-col items-center w-full">
                        <div className="channel-switcher flex flex-wrap gap-x-2">
                            <button
                                className={channel === 0 && 'active'}
                                onClick={() => setChannel(0)}
                            >
                                Web App
                            </button>

                            <button
                                className={channel === 1 && 'active'}
                                onClick={() => setChannel(1)}
                            >
                                WhatsApp
                            </button>

                            <button
                                className={channel === 2 && 'active'}
                                onClick={() => setChannel(2)}
                            >
                                USSD <span className='badge discount-tag ml-2'>Coming soon</span>
                            </button>
                        </div>

                        {channel === 0 && <div className="content p-4 md:p-8 mt-16 w-full">
                            <div className="flex md:flex-row flex-col gap-4">
                                <div data-aos="fade-up" className="feature-card">
                                    <div className="image" >
                                        <video src={QrcodeVideo} autoPlay={true} loop muted></video>
                                    </div>
                                    <div className="content w-full p-4">
                                        <h5 className="base-text font-bold mb-2 secondary-400">Get feedback with a unique <span className='primary-500'>QR code</span></h5>
                                        <p className='secondary-300 base-text'>Receive feedback from your customers when they scan your unique QR code</p>
                                    </div>
                                </div>
                                
                                <div data-aos="fade-up" data-aos-delay="100" className="feature-card">
                                    <div className="image" >
                                        <img src={UniqueLink} className="-mt-[70%]" alt='unique link'/>
                                    </div>
                                    <div className="content p-4">
                                        <h5 className="base-text font-bold mb-2 secondary-400">Receive feedback using a <span className='primary-500'>unique link</span></h5>
                                        <p className='secondary-300 base-text'>Sharing a unique link with your audience allows you to easily receive useful feedback</p>
                                    </div>
                                </div>


                                <div data-aos="fade-up" data-aos-delay="200" className="feature-card">
                                    <div className="image justify-center" >
                                        <div className='url-shortener'>
                                            <div className="link-input secondary-300">
                                                <div className={shortenUrl ? 'dittolink shorten' : 'dittolink'}>
                                                    https://clientshot.com/dittohub
                                                    <br /> <br />
                                                    https://clientshot.com/dhub
                                                </div>
                                                
                                            </div>
                                            <button className='btn btn-primary mockup-btn-copy'>Copy link</button>
                                        </div>
                                        <div className='mt-3 items-center flex cursor-pointer'>
                                            <input type="checkbox" name="" aria-label="check" id="" className="cursor-pointer" onClick={() => setshortenUrl(!shortenUrl)}  checked={shortenUrl} />
                                            <span className="ml-2 secondary-300 small-text font-medium" onClick={() => setshortenUrl(!shortenUrl)}>Click to shorten url</span>
                                        </div>
                                    </div>
                                    <div className="content p-4">
                                        <h5 className="base-text font-semibold mb-2 secondary-400">Use a <span className='primary-500'>shortened URL</span></h5>
                                        <p className='secondary-300 base-text'>Make your unique url more memorable with a shortened URL</p>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {channel === 1 && 
                            <div className="channel-tab whatsapp justify-center p-4 md:p-8 mt-16">

                            <div className="flex justify-center flex-col md:flex-row">
                                <div className="content order-first md:order-last w-full">
                                
                                        <div className='mb-4'> 
                                            <div className="heading-six font-bold mb-2 secondary-400">Leverage WhatsApp integration</div>
                                            <p className='secondary-300 small-text'>Collect feedback from users who prefer using WhatsApp</p>
                                        </div>

                                        <div className="feature-card items-center flex flex-col h-[300px]">
                                                <div className='url-shortener mt-16'>
                                                    <div className="link-input secondary-300">
                                                        <div className={shortenUrl ? 'dittolink shorten' : 'dittolink'}>
                                                            https://wa.me/+234902300002
                                                            <br /> <br />
                                                            https://clientshot.com/dhub
                                                        </div>
                                                
                                                    </div>
                                                    <button className='btn btn-primary mockup-btn-copy'>Copy link</button>
                                                </div>

                                            <div className="content p-4">
                                                <h5 className="base-text font-bold mb-2 secondary-400">Get feedback with a <span className='primary-500'>WhatsApp link</span></h5>
                                                <p className='secondary-300 small-text'>Receive feedback from your customers when they scan your unique QR code</p>
                                            </div>
                                        </div>
                                        
                                </div>
                                
                                <div data-aos="zoom-in-up" className="w-full  flex justify-center">
                                        <video src={whatsappMockup} loop autoPlay={true} alt="" className="w-[300px]" />
                                </div>                                
                            </div>
                        </div>
                        }

                        {channel === 2 && 
                            <div className="channel-tab justify-center p-4 md:p-8 mt-16">

                            <div className="flex justify-center flex-col md:flex-row ">
                                <div className="content md:mt-40 md:w-2/5">
                                    <div className='ussd-content'>
                                        <div data-aos="fade-up" className="heading-six font-bold mb-2 secondary-400 ">Offline feedback for Tech-Novices</div>
                                        <p data-aos="fade-up" className='secondary-300 small-text'>Facilitate feedback collection from customers less familiar with technology, especially useful when internet access is unavailable.</p>
                                    </div>
                                    
                                </div>
                                
                                <div data-aos="zoom-in-up" className="mockup">
                                        <img src={ussdMockup} loading="lazy" alt="USSD feedback collection interface" className="w-[300px]" />
                                </div>

                                
                            </div>
                        </div>
                        }

                    </div>
                </div>
                        </div>
                    </div>
                </div>

                {/* Resolution Section */}
                <div className='pt-40 '>

                    <div className='md:flex justify-between gap-4 items-start p-8'>
                        <div className='resolute-texts md:sticky top-56'>
                            <div data-aos="fade-up" className="pill secondary-400 small-text mb-4">
                                    <img src={ResolutionIcon} alt="resolution icon" />
                                    Resolution
                                </div>
                                
                                <div data-aos="fade-up" className="heading-four mb-6 secondary-400"> Manage and <span className='primary-500'>resolve</span> customer complaints</div>
                                <div data-aos="fade-up" className="base-text secondary-400 font-normal">
                                    A simplified solution that allows you to efficiently monitor, track, and resolve customer issues as they arise.
                                </div>
                        </div>

                        <div data-aos="zoom-in-up" className='md:w-9/12'>
                            <div className="resolution-feature mb-8">
                                <div className="content p-4">
                                    <div className="heading-six font-bold mb-2 secondary-400"><span className='primary-500'>Hands-on</span> Ticketing</div>
                                    <p className='secondary-300 small-text'>Manually create complaint tickets for customers who voice their concerns in person, ensuring their issues are promptly addressed and resolved.</p>
                                    <div className="image">
                                        <img src={HandsOnMockup} loading="lazy" alt="handson mockup" />
                                    </div>
                                </div>
                            </div>

                            <div className="resolution-feature mb-8">
                                <div className="content p-4">
                                    <div className="heading-six font-bold mb-2 secondary-400"><span className='primary-500'>Assign</span>  complaints to teammates</div>
                                    <p className='secondary-300 small-text'>Delegate customer complaints to team members, boost productivity and resolve issues faster.</p>
                                    <div className="image flex justify-center">
                                        <video data-aos="fade" className='mobile-optimized h-[600px]' src={UnassignVid} autoPlay={true} loop muted></video>
                                    </div>
                                </div>
                            </div>

                            <div className="resolution-feature">
                                <div className="content p-4">
                                    <div className="heading-six font-bold mb-2 secondary-400">Informative Status <span className='primary-500'>Updates</span></div>
                                    <p className='secondary-300 small-text'>Move tickets from 'In Progress' to 'Done,' keeping your customers in the loop throughout the complaint resolution process.</p>
                                    <div className="image flex justify-center">
                                        <video data-aos="fade" className='mobile-optimized h-[600px]' src={UpdateStatus} autoPlay={true} loop muted></video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="hrline-alt w-full mb-8 mt-16"></div>

                {/* Engagement Section */}
                <div className='mt-24 md:mt-0 md:pr-8 engagement-section'>
                    <div className='flex flex-col items-center justify-center'>
                        <div data-aos="fade-up" className="pill secondary-400 small-text mb-4">
                            <img src={EngagementIcon} alt="" />
                            Engagement
                        </div>
                        
                        <div data-aos="fade-up" className="heading-four mb-6 text-center secondary-400"> <span className='primary-500'>Engage</span> your customers when they respond </div>
                        
                        <div className='flex w-full flex-col md:flex-row justify-between md:items-center p-8 gap-12'>

                            <div className="engagement-tab">
                                <button className={engagement === 0 ? 'active' : ''} onClick={() => setEngagement(0)}>
                                    Chat
                                    {engagement === 0 ? <img src={ArrowRight} alt="" /> : <></>}
                                    </button>
                                <button className={engagement === 1 ? 'active' : ''}  onClick={() => setEngagement(1)}>
                                    Text message
                                    {engagement === 1 ? <img src={ArrowRight} alt="" /> : <></>}
                                </button>
                            </div>

                            {engagement === 0 && <div className='flex items-center gap-12 text-message flex-col md:flex-row '>
                                <div data-aos="zoom-in-up" className='order-last md:order-first'>
                                    <img src={ChatScreen} loading="lazy" className='mockup02 max-w-[552px]' alt="Customer chat feedback interface" />
                                </div>
                                <div className='md:w-9/12'>
                                
                                    <div data-aos="fade-up" className="heading-five mb-2 md:mb-6 secondary-400"> Team-Enabled Customer <span className='primary-500'>Chat</span></div>
                                    <div data-aos="fade-up" className="base-text secondary-400 font-normal">
                                    Initiate a secure chat with customers online to identify and promptly resolve their issues. And yes, team members can join the conversation if necessary.
                                    </div>
                                </div>
                            </div>}

                            {engagement === 1 && <div className='flex items-center gap-12 text-message flex-col md:flex-row '>
                                <div data-aos="zoom-in-up" className='order-last md:order-first'>
                                    <img src={TextScreen} loading="lazy" className='mockup02 max-w-[552px]' alt="SMS text messaging feedback interface" />
                                </div>
                                <div className='md:w-9/12'>
                                
                                    <div data-aos="fade-up" className="heading-five mb-2 md:mb-6 secondary-400"> Resolution Updates and <span className='primary-500'>SMS Marketing</span></div>
                                    <div data-aos="fade-up" className="base-text secondary-400 font-normal">
                                    Keep customers updated on issue resolutions. This communication method is also effective for SMS marketing.
                                    </div>
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>

                {/* Analysis Section */}
                <div data-aos="fade" className='mt-40 md:pr-8 p-4 md:p-8' >
                    <div className='flex flex-col md:flex-row justify-between md:items-center p-4 md:p-8 gap-12 rounded-lg analysis-section' >
                    <div data-aos="zoom-in-up" className='order-last'>
                        <img src={DashboardMockup} loading="lazy" className='mockup02 analyse-dashboard mt-40 max-w-full' alt="Clientshot analytics dashboard showing feedback data" />
                    </div>

                    <div className='md:w-9/12'>
                        <div data-aos="fade-up" className="pill secondary-400 small-text mb-4">
                            <img src={AnalyseIcon} alt="" />
                            Analysis
                        </div>
                        <div data-aos="fade-up" className="heading-four mb-6 secondary-400"><span className='primary-500'>Analyze</span> the data you collect </div>
                        <div data-aos="fade-up" className="base-text secondary-400 font-normal">
                        Our advanced reporting tool will help you analyze your feedback data so you can better understand it and respond. It also tells you which service points are performing well, which channels your customers prefer to use to respond to a survey, and more.
                        </div>
                    </div>

                    </div>
                </div>

                <div className="hrline w-full mb-8 mt-16"></div>

                {/* Clients/Logos */}
                <div data-aos="fade" className='mt-24 md:mt-0 flex flex-col items-center md:pr-8 p-4 md:p-8 clients overflow-hidden'>
                    <div data-aos="fade-up" className="heading-four text-center mb-12 secondary-400"> Providing data insights for the top leading companies </div>
                    <div data-aos="fade" className='flex gap-8 md:gap-24 flex-wrap justify-center'>
                        <img src={Ihvn} className='client' alt="IHVN" />
                        <img src={Valuejet} className='client' alt="Valuejet" />
                        <img src={Firmcare} className='client' alt="Firmcare" />
                        <img src={Ditto} className='client' alt="Ditto" />
                    </div>
                </div>

                <div className="hrline-alt w-full mb-8 mt-16"></div>

                {/* Testimonials */}
                <div className=' mt-24 md:mt-0 md:pr-8 story-section'>
                    <div className='flex flex-col items-center justify-center'>
                        <div data-aos="fade-up" className="pill secondary-400 small-text mb-4">
                            <img src={TrophyIcon} alt="" />
                            Client success stories
                        </div>
                        
                        <div data-aos="fade-up" className="heading-four text-center mb-6 secondary-400">See how businesses like yours have benefited</div>
                        
                        <div className='grid grid-cols-1 md:grid-cols-3 gap-6 p-4 md:px-32'>
                            <div  data-aos="fade" >
                                <div className="testimony">
                                    <div className="flex justify-start items-center gap-2">
                                    <img src={pfp2} className='pfp' alt="" />
                                        <div className="info">
                                            <p className="secondary-400 font-medium base-text">Akande Omobolanle</p>
                                            <p className="secondary-200 small-text">Marketing Manager, Bright Ideas Inc.</p>
                                        </div>
                                    </div>
                                    <div className="comment secondary-300 small-text">
                                        With this tool, collecting feedback from our customers has never been easier! Highly recommended.
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade" data-aos-delay="100">
                                <div  className="testimony">
                                    <div className="flex justify-start items-center gap-2">
                                    <img src={pfp1} className='pfp' alt="" />
                                        <div className="info">
                                            <p className="secondary-400 font-medium base-text">Eze Chinedu</p>
                                            <p className="secondary-200 small-text">Customer Support Specialist, Service Excellence Inc.</p>
                                        </div>
                                    </div>
                                    <div className="comment secondary-300 small-text">
                                    We've received such positive feedback from our customers since implementing this tool. It's user-friendly and effective!
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade" data-aos-delay="200">
                                <div className="testimony">
                                    <div className="flex justify-start items-center gap-2">
                                        <img src={pfp3} className='pfp' alt="" />
                                        <div className="info">
                                            <p className="secondary-400 font-medium base-text">Tofunmi Akinlade</p>
                                            <p className="secondary-200 small-text">Operations Coordinator, Peak Performance Solutions</p>
                                        </div>
                                    </div>
                                    <div className="comment secondary-300 small-text">
                                    A game-changer for us! The unique links and QR codes make feedback collection a breeze
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade" >
                                <div className="testimony">
                                    <div className="flex justify-start items-center gap-2">
                                    <img src={pfp4} className='pfp' alt="" />
                                        <div className="info">
                                            <p className="secondary-400 font-medium base-text">Oladejo israel</p>
                                            <p className="secondary-200 small-text">Sales Representative, Innovate Technologies.</p>
                                        </div>
                                    </div>
                                    <div className="comment secondary-300 small-text">
                                    Our customers love the simplicity of providing feedback using this tool. It's a win-win for everyone!
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade" data-aos-delay="100" >
                                <div className="testimony">
                                    <div className="flex justify-start items-center gap-2">
                                    <img src={pfp5} className='pfp' alt="" />
                                        <div className="info">
                                            <p className="secondary-400 font-medium base-text">Adegboyoga Precious</p>
                                            <p className="secondary-200 small-text">IT Manager, Digital Dynamics</p>
                                        </div>
                                    </div>
                                    <div className="comment secondary-300 small-text">
                                    An essential tool for any business looking to gather valuable insights from their customers. Fantastic!
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade" data-aos-delay="200">
                                <div className="testimony">
                                    <div className="flex justify-start items-center gap-2">
                                        <img src={pfp6} className='pfp' alt="" />
                                        <div className="info">
                                            <p className="secondary-400 font-medium base-text">Aminat Taiwo </p>
                                            <p className="secondary-200 small-text">Project Manager, Stellar Solutions Ltd.
                                </p>
                                        </div>
                                    </div>
                                    <div className="comment secondary-300 small-text">
                                    The customizable options for feedback collection make this tool stand out. It's been a great asset to our company.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Video Popup */}
                {
                    popup && (
                        <div data-aos="zoom-up" className="popup h-full w-full">
                            <div className="main-video flex flex-col gap-y-4 items-center">
                                <iframe width="800" height="600" className="rounded-[15px]" src="https://www.youtube.com/embed/_QmyvFOasGk?si=2lLN11xULFRPBSNK&autoplay=1" allow='autoplay; encrypted-media' allowfullscreen title="Client Shot Video"></iframe>
                                <button onClick={() => setPopup(false)} className='flex gap-2'>
                                    <img src={Close} alt="" /> Close
                                </button>
                            </div>

                        </div>
                    )
                }

                {/* Bottom CTA Section */}
                <section className="home-election-cta-wrap px-4 md:px-8">
                    <div className="home-election-cta">
                        <div className="home-election-cta-copy">
                            <h2 className="heading-four text-white">
                                Nigeria&apos;s Voice. <br />Captured in Real Time.
                            </h2>
                            <p className="base-text text-white">
                                Thousands of Nigerians are sharing their views, exploring live election trends, and contributing to one of the country&apos;s largest public opinion initiatives.
                            </p>
                            <div className="home-election-cta-actions">
                                <Link to="/election-pulse" className="btn btn-primary">
                                    Explore Election Pulse
                                </Link>
                                <button type="button" onClick={() => setPopup(true)} className="btn btn-secondary">
                                    View Live Results
                                </button>
                            </div>
                        </div>

                        <div className="home-election-cta-media">
                            <img src={CtaMockup} loading="lazy" className="w-full h-auto" alt="Election Pulse displayed across devices" />
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <FaqSection content={faqContent} />
            </div>
        </>
    )
}

export default Home
